declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    xsText: true;
    sText: true;
    mText: true;
    lText: true;
    xlText: true;
    xxlText: true;
    strongText: true;
    buttonText: true;
  }
}

const pxToRem = (px: number): string => `${px / 16}rem`;

export const MuiTypography = {
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        mText: 'span',
        lText: 'h3',
        xlText: 'h2',
        xxlText: 'h1',
        strongText: 'strong',
      },
    },
  },
};

export const MuiCssBaseline = {
  MuiCssBaseline: {
    styleOverrides: `
        body {
          font-weight: 500;
        }
        @font-face {
          font-style: normal;
          font-display: swap;
          font-weight: 500;
        }
        @font-face {
            font-style: normal;
            font-display: swap;
            font-weight: 600;
        }
        @font-face {
          font-style: normal;
          font-display: swap;
          font-weight: 700;
        }`,
  },
};

const typography = {
  fontFamily: 'Manrope, sans-serif',
  xsText: {
    fontSize: pxToRem(12),
    fontWeight: 500,
    lineHeight: pxToRem(16),
  },
  sText: {
    fontSize: pxToRem(12),
    fontWeight: 500,
    lineHeight: pxToRem(16),
  },
  mText: {
    fontSize: pxToRem(14),
    lineHeight: pxToRem(20),
    fontWeight: 500,
  },
  lText: {
    fontSize: pxToRem(18),
    lineHeight: pxToRem(24),
    fontWeight: 500,
  },
  xlText: {
    fontSize: pxToRem(24),
    lineHeight: pxToRem(28),
    fontWeight: 500,
  },
  xxlText: {
    fontSize: pxToRem(36),
    lineHeight: pxToRem(48),
    fontWeight: 500,
  },
  strongText: {
    fontWeight: 600,
  },
  buttonText: {
    fontSize: pxToRem(14),
    fontWeight: 700,
    lineHeight: 1.215,
  },
};

export default typography;
